import React, { Suspense } from 'react';
import { Stepper } from './Stepper';
import { Skeleton } from './Skeleton';
import { useLocation } from 'react-router-dom';
import { STEPS } from '../utils/constants';

const Header = React.lazy(() => import('./layout/Header').then(m => ({ default: m.Header })));
const WorkingHours = React.lazy(() => import('./layout/WorkingHours').then(m => ({ default: m.WorkingHours })));
const Footer = React.lazy(() => import('./layout/Footer').then(m => ({ default: m.Footer })));

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const { pathname } = useLocation();
  const currentStepIndex = STEPS.findIndex(s => pathname.startsWith(s.path));
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Suspense fallback={<div className="w-full bg-white border-b border-gray-100"><div className="max-w-6xl mx-auto px-4 py-3"><Skeleton lines={2} /></div></div>}>
        <Header />
        {/* </Suspense> */}
        <div className="flex-1 max-w-6xl mx-auto w-full grid grid-cols-1 md:grid-cols-10 gap-0 md:gap-6 px-0 md:px-4 py-6">
          <div className="block md:hidden px-4 mb-4">
            <div className="text-center text-xs font-bold text-gray-500 uppercase tracking-wide">
              Step {currentStepIndex + 1} of {STEPS.length}
            </div>
          </div>
          <div className="hidden md:block md:col-span-2 bg-white md:bg-transparent md:border-0 md:rounded-none">
            <Stepper />
          </div>
          <main className="px-2 md:p-0 md:col-span-8">
            {children}
          </main>
        </div>
        {/* <Suspense fallback={<div className="w-full bg-white border-b border-gray-100"><div className="max-w-6xl mx-auto px-4 py-3"><Skeleton lines={2} /></div></div>}> */}
        <WorkingHours />
          <Footer />
      </Suspense>
    </div>
  );
};
